import React, { Component } from "react"
import { connect } from "react-redux"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import LoadingButton from "../../components/LoadingButton"
import Button from "@material-ui/core/Button"
import {
  toggleAddClientDialog,
  toggleDeleteClientDialog,
  deleteClient,
  _setEditClient,
  getClientList,
  getClientCompanies,
  _setEditClientCompany,
  toggleDeleteClientCompanyDialog,
  deleteClientCompany,
} from "../../actions/clients"
import { openSnackBar } from "../../actions/snack-bar"
import Typography from "@material-ui/core/Typography"
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined"

class DeleteClientCompanyDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      deleteCompanyLoading: false
    }
  }

  handleClose = () => {
    this.props.dispatch(toggleDeleteClientCompanyDialog(false))
    this.props.dispatch(_setEditClientCompany())
  }
  deleteClient = () => {
    const { client } = this.props

    this.setState({
      deleteCompanyLoading: true
    })


    this.setState({
      savingProfile: false,
    })
    this.props
      .dispatch(deleteClientCompany(client.id))
      .then(res => {
        this.setState({
          savingProfile: false,
        })
        this.props.dispatch(
          openSnackBar({
            message: res.message,
          })
        )
        this.props.dispatch(getClientCompanies()).then(() => {
          this.setState({ deleteCompanyLoading: false })
          this.props.dispatch(toggleDeleteClientCompanyDialog(false))
          this.props.dispatch(_setEditClientCompany())
        }).catch((err) => {
          this.setState({ deleteCompanyLoading: false })
          this.props.dispatch(toggleDeleteClientCompanyDialog(false))
          this.props.dispatch(_setEditClientCompany())
        })
        this.props.dispatch(getClientList())
      })
      .catch(err => {
        this.setState({
          savingProfile: false,
        })
        this.props.dispatch(
          openSnackBar({
            message: "There was an unknown error",
          })
        )
        return
      })
  }
  render() {
    const { fullScreen, classes } = this.props
    return (
      <Dialog
        fullScreen={fullScreen}
        open={this.props.deleteClientCompanyDialogOpen}
        onClose={this.handleClose}
        onEntered={this.setUpForm}
        onExited={this.clearState}
        aria-labelledby="responsive-dialog-title"
      >
        <form id="edit-form" noValidate autoComplete="off">
          <DialogTitle
            disableTypography
            style={{
              textAlign: "center",
            }}
          >
            <DeleteOutlinedIcon
              style={{
                color: "#dc004e",
                cursor: "pointer",
              }}
              onClick={this.deleteClient}
              aria-label="Close"
            />
            <Typography variant="h6">
              {"Are you sure you want to remove ?"}
            </Typography>
            <Typography variant="h6">
              {"This action cannot be undone."}
            </Typography>
          </DialogTitle>
          <DialogContent />
          <DialogActions>
            <Button variant="contained" onClick={this.handleClose}>
              Cancel
            </Button>
            <LoadingButton
              style={{ color: "#f1f1f1", backgroundColor: "#d73a49" }}
              buttonclicked={this.deleteClient}
              type="button"
              working={this.state.deleteCompanyLoading}

            >
              Remove
            </LoadingButton>
          </DialogActions>
        </form>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    deleteClientCompanyDialogOpen: state.clients.deleteClientCompanyDialogOpen,
    client: state.clients.editClientCompany,
  }
}
const connector = connect(mapStateToProps)

export default connector(DeleteClientCompanyDialog)
